"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var MDIcon_1 = require("../../../components/MDIcon");
var Row_1 = require("../../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var CJFormContext_1 = require("../CJFormContext");
var util_1 = require("../util");
var CJField_1 = require("./CJField");
var GenericInput = function (props) {
  var _a = (0, react_1.useContext)(CJFormContext_1.CJFormContext),
    register = _a.register,
    formState = _a.formState,
    setValue = _a.setValue,
    watch = _a.watch;
  var _b = __read((0, util_1.extractRegister)(props), 2),
    _c = _b[0],
    registerProps = _b[1],
    name = _c.name,
    className = _c.className,
    rightAlignText = _c.rightAlignText,
    icon = _c.icon,
    rowProps = _c.rowProps,
    clearable = _c.clearable,
    restProps = __rest(_c, ["name", "className", "rightAlignText", "icon", "rowProps", "clearable"]);
  var iconElement = typeof icon === "string" ? (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
    size: 20,
    icon: icon
  }) : icon;
  var val = watch(name);
  var min = getValueFromValidationRule(registerProps.min);
  var max = getValueFromValidationRule(registerProps.max);
  var cn = (0, classnames_1.default)("vsx-cjform-generic-input-wrapper", formState.errors[name] && "error", className, props.type === "hidden" && "vsx-cjform-input-hidden");
  var _d = (0, react_1.useContext)(CJField_1.CJFieldContext),
    fieldName = _d.fieldName,
    fieldGuid = _d.fieldGuid;
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    gap: "small",
    align: "center",
    justify: "space-between",
    paddingLeft: "medium",
    paddingRight: clearable ? "xl" : undefined
  }, rowProps, {
    className: cn
  }, {
    children: [iconElement, (0, jsx_runtime_1.jsx)("input", __assign({
      id: fieldName === name ? fieldGuid : undefined
    }, restProps, {
      min: min,
      max: max,
      style: __assign({
        textAlign: rightAlignText ? "right" : undefined
      }, restProps.style)
    }, register(name, registerProps))), clearable && val && (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      clickable: true,
      icon: "close",
      color: "#AAA",
      style: {
        transform: "scale(0.8)"
      },
      size: 20,
      onClick: function () {
        return setValue(name, undefined);
      }
    })]
  }));
};
exports.GenericInput = GenericInput;
var getValueFromValidationRule = function (rule) {
  if (typeof rule === "number" || typeof rule === "string") {
    return rule;
  }
  if (rule !== undefined) {
    return rule.value;
  }
  return undefined;
};